export function deriveDisplayNameFromNames(firstName: string, lastName: string): string {
  return [firstName.trim(), lastName.trim()].filter(Boolean).join(" ");
}

export function contactInitials(
  displayName: string,
  firstName?: string | null,
  lastName?: string | null,
): string {
  const first = firstName?.trim().charAt(0) ?? "";
  const last = lastName?.trim().charAt(0) ?? "";
  const fromNames = `${first}${last}`;
  if (fromNames) return fromNames.toLocaleUpperCase();

  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0]!.charAt(0)}${parts[1]!.charAt(0)}`.toLocaleUpperCase();
  }

  const fallback = displayName.trim().slice(0, 2);
  return fallback ? fallback.toLocaleUpperCase() : "?";
}
